import request from '@/utils/request'

/**
 * 账户信息
 * @param {*} data
 * @returns
 */
export function getLoanInfo(data, headers) {
    return request({
        url: '2705a25c107031a769',
        method: 'post',
        data,
        headers,
    })
}

/**
 * 账户信息
 * @param {*} data
 * @returns
 */
export function getProductinfo(data, headers) {
    return request({
        url: 'e86df2f1183398389e',
        method: 'post',
        data,
        headers,
    })
}

/**
 * 创建临时订单
 * @param {*} data
 * @returns
 */
export function createOrder(data, headers) {
    return request({
        url: '3699619e2c878fb163',
        method: 'post',
        data,
        headers,
    })
}

/**
 * 试算
 * @param {*} data
 * @returns
 */
export function calculationTrial(data, headers) {
    return request({
        url: 'dc88446b06bb323ed5',
        method: 'post',
        data,
        headers,
    })
}

/**
 * 订单确认
 * @param {*} data
 * @returns
 */
export function confirmOrder(data, headers) {
    return request({
        url: '5b07928cd7a2878469',
        method: 'post',
        data,
        headers,
    })
}

/**
 * 放款确认
 * @param {*} data
 * @returns
 */
export function confirmLoan(data, headers) {
    return request({
        url: '480b485e4b11483c75',
        method: 'post',
        data,
        headers,
    })
}

/**
 * 还款信息
 * @param {*} data
 * @returns
 */
export function repaymentInfo(data, headers) {
    return request({
        url: 'c370021e608cb72c86',
        method: 'post',
        data,
        headers,
    })
}

/**
 * 订单列表
 * @param {*} data
 * @returns
 */
export function orderListAll(data, headers) {
    return request({
        url: '472b2b8966551cd927',
        method: 'post',
        data,
        headers,
    })
}

/**
 * 重新放款
 * @param {*} data
 * @returns
 */
export function retryLoan(data, headers) {
    return request({
        url: '3c3abbd5c4b5a2b92c',
        method: 'post',
        data,
        headers,
    })
}

